

// import React, { useEffect, useState } from "react";
// import {
//   getAllCompanies,
//   approveCompany,
//   rejectCompany,
// } from "../../../services/adminService";
// import {
//   Button,
//   Table,
//   Spinner,
//   Alert,
//   Badge,
//   Modal,
//   Image,
//   Row,
//   Col,
// } from "react-bootstrap";

// const CompanyApproval = () => {
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [selectedCompany, setSelectedCompany] = useState(null);
//   const [showDetailModal, setShowDetailModal] = useState(false);

//   const fetchCompanies = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await getAllCompanies();
//       setCompanies(res.data || []);
//     } catch (err) {
//       setError("Failed to fetch companies.");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCompanies();
//   }, []);

//   const handleApprove = async () => {
//     if (!selectedCompany) return;
//     setLoading(true);
//     try {
//       await approveCompany(selectedCompany._id);
//       setCompanies((prev) =>
//         prev.map((c) =>
//           c._id === selectedCompany._id ? { ...c, isApproved: true } : c
//         )
//       );
//       setShowDetailModal(false);
//       setSelectedCompany(null);
//     } catch (err) {
//       setError("Failed to approve company.");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleReject = async () => {
//     if (!selectedCompany) return;
//     setLoading(true);
//     try {
//       await rejectCompany(selectedCompany._id);
//       setCompanies((prev) => prev.filter((c) => c._id !== selectedCompany._id));
//       setShowDetailModal(false);
//       setSelectedCompany(null);
//     } catch (err) {
//       setError("Failed to reject company.");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <h2 className="mb-4 text-center fw-bold">🏢 Company Approval Management</h2>

//       {error && <Alert variant="danger">{error}</Alert>}

//       {loading ? (
//         <div className="text-center">
//           <Spinner animation="border" />
//         </div>
//       ) : (
//         <Table
//           striped
//           bordered
//           hover
//           responsive
//           className="align-middle text-center shadow-sm"
//         >
//           <thead className="table-dark">
//             <tr>
//               <th>#</th>
//               <th>Logo</th>
//               <th>Company Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Category / SubCategory</th>
//               <th>Status</th>
//               <th>Registered By</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {companies.length > 0 ? (
//               companies.map((company, index) => (
//                 <tr key={company._id}>
//                   <td>{index + 1}</td>
//                   <td>
//                     {company.logo ? (
//                       <Image
//                         src={company.logo}
//                         alt={company.name}
//                         width={50}
//                         rounded
//                       />
//                     ) : (
//                       "N/A"
//                     )}
//                   </td>
//                   <td>{company.name}</td>
//                   <td>{company.email}</td>
//                   <td>{company.phone}</td>
//                   <td>
//                     {company.category?.name || "N/A"} /{" "}
//                     {company.subCategory?.name || "N/A"}
//                   </td>
//                   <td>
//                     <Badge bg={company.isApproved ? "success" : "warning"}>
//                       {company.isApproved ? "Approved" : "Pending"}
//                     </Badge>
//                   </td>
//                   <td>{company.registeredBy?.name || "N/A"}</td>
//                   <td>
//                     <Button
//                       size="sm"
//                       variant="info"
//                       className="me-2"
//                       onClick={() => {
//                         setSelectedCompany(company);
//                         setShowDetailModal(true);
//                       }}
//                     >
//                       🔍 View Details
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="text-center text-muted">
//                   No companies found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       {/* Full Detail Modal */}
//       <Modal
//         show={showDetailModal}
//         onHide={() => setShowDetailModal(false)}
//         size="x"
//         centered
//         scrollable
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Company Full Details</Modal.Title>
//         </Modal.Header>
//         {selectedCompany && (
//           <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
//             <Row className="mb-3">
//               <Col md={4}>
//                 {selectedCompany.logo && (
//                   <Image
//                     src={selectedCompany.logo}
//                     alt="Logo"
//                     fluid
//                     rounded
//                     style={{ maxHeight: "150px" }}
//                   />
//                 )}
//               </Col>
//               <Col md={8}>
//                 <h4>{selectedCompany.name}</h4>
//                 <p>
//                   <b>Email:</b> {selectedCompany.email}
//                 </p>
//                 <p>
//                   <b>Phone:</b> {selectedCompany.phone}
//                 </p>
//                 <p>
//                   <b>Website:</b>{" "}
//                   <a href={selectedCompany.website} target="_blank">
//                     {selectedCompany.website}
//                   </a>
//                 </p>
//                 <p>
//                   <b>Google Maps:</b>{" "}
//                   <a href={selectedCompany.googleMapsLink} target="_blank">
//                     {selectedCompany.googleMapsLink}
//                   </a>
//                 </p>
//                 <p>
//                   <b>Description:</b> {selectedCompany.description}
//                 </p>
//                 <p>
//                   <b>Type:</b> {selectedCompany.companyType}
//                 </p>
//                 <p>
//                   <b>Category/SubCategory:</b>{" "}
//                   {selectedCompany.category?.name || "N/A"} /{" "}
//                   {selectedCompany.subCategory?.name || "N/A"}
//                 </p>
//                 <p>
//                   <b>GST Number:</b> {selectedCompany.gstNumber}
//                 </p>
//                 <p>
//                   <b>Aadhaar Number:</b> {selectedCompany.aadhaarNumber}
//                 </p>
//                 <p>
//                   <b>Registered By:</b>{" "}
//                   {selectedCompany.registeredBy?.name} (
//                   {selectedCompany.registeredBy?.email})
//                 </p>
//                 <p>
//                   <b>Status:</b>{" "}
//                   {selectedCompany.isApproved ? "Approved" : "Pending"}
//                 </p>
//               </Col>
//             </Row>

//             <h5>Business Timings</h5>
//             <Table size="sm" bordered>
//               <thead>
//                 <tr>
//                   <th>Day</th>
//                   <th>Open</th>
//                   <th>Close</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {selectedCompany.businessTimings &&
//                   Object.entries(selectedCompany.businessTimings).map(
//                     ([day, timing]) => (
//                       <tr key={day}>
//                         <td>{day.charAt(0).toUpperCase() + day.slice(1)}</td>
//                         <td>{timing.open || "--"}</td>
//                         <td>{timing.close || "--"}</td>
//                       </tr>
//                     )
//                   )}
//               </tbody>
//             </Table>

//             <h5>Documents</h5>
//             <Row>
//               {selectedCompany.aadhaarImage && (
//                 <Col md={4} className="mb-2">
//                   <p>Aadhaar</p>
//                   <a href={selectedCompany.aadhaarImage} target="_blank">
//                     <Image
//                       src={selectedCompany.aadhaarImage}
//                       fluid
//                       rounded
//                       style={{ maxHeight: "150px" }}
//                     />
//                   </a>
//                 </Col>
//               )}
//               {selectedCompany.panImage && (
//                 <Col md={4} className="mb-2">
//                   <p>PAN</p>
//                   <a href={selectedCompany.panImage} target="_blank">
//                     <Image
//                       src={selectedCompany.panImage}
//                       fluid
//                       rounded
//                       style={{ maxHeight: "150px" }}
//                     />
//                   </a>
//                 </Col>
//               )}
//               {selectedCompany.electricityBillImage && (
//                 <Col md={4} className="mb-2">
//                   <p>Electricity Bill</p>
//                   <a
//                     href={selectedCompany.electricityBillImage}
//                     target="_blank"
//                   >
//                     <Image
//                       src={selectedCompany.electricityBillImage}
//                       fluid
//                       rounded
//                       style={{ maxHeight: "150px" }}
//                     />
//                   </a>
//                 </Col>
//               )}
//               {selectedCompany.passportPhoto && (
//                 <Col md={4} className="mb-2">
//                   <p>Passport Photo</p>
//                   <a href={selectedCompany.passportPhoto} target="_blank" rel="noopener noreferrer">
//                     <Image
//                       src={selectedCompany.passportPhoto}
//                       fluid
//                       rounded
//                       style={{ maxHeight: "150px" }}
//                     />
//                   </a>
//                 </Col>
//               )}



//             </Row>

//             <h5>Banners</h5>
//             <Row>
//               {selectedCompany.banner?.map((b, i) => (
//                 <Col md={4} className="mb-2" key={i}>
//                   <Image src={b} fluid rounded style={{ maxHeight: "150px" }} />
//                 </Col>
//               ))}
//             </Row>

//             <h5>Keywords</h5>
//             <p>
//               {selectedCompany.keywords?.length
//                 ? selectedCompany.keywords.join(", ")
//                 : "N/A"}
//             </p>

//             <h5>Photos</h5>
//             <Row>
//               {selectedCompany.photos?.length ? (
//                 selectedCompany.photos.map((p, i) => (
//                   <Col md={4} className="mb-2" key={i}>
//                     <Image src={p} fluid rounded style={{ maxHeight: "150px" }} />
//                   </Col>
//                 ))
//               ) : (
//                 <Col>
//                   <p>N/A</p>
//                 </Col>
//               )}
//             </Row>
//           </Modal.Body>
//         )}
//         <Modal.Footer className="d-flex justify-content-between">
//           <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
//             Close
//           </Button>
//           <div>
//             {!selectedCompany?.isApproved && (
//               <Button variant="success" onClick={handleApprove} className="me-2">
//                 ✅ Approve
//               </Button>
//             )}
//             <Button variant="danger" onClick={handleReject}>
//               ❌ Reject
//             </Button>
//           </div>
//         </Modal.Footer>
        
//       </Modal>
//     </div>
//   );
// };

// export default CompanyApproval;



import React, { useEffect, useState } from "react";
import {
  getAllCompanies,
  approveCompany,
  rejectCompany,
} from "../../../services/adminService";
import {
  Button,
  Table,
  Spinner,
  Alert,
  Badge,
  Modal,
  Image,
  Row,
  Col,
} from "react-bootstrap";

const CompanyApproval = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  // NEW SEARCH STATE
  const [searchQuery, setSearchQuery] = useState("");

  const fetchCompanies = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getAllCompanies();
      setCompanies(res.data || []);
    } catch (err) {
      setError("Failed to fetch companies.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const handleApprove = async () => {
    if (!selectedCompany) return;
    setLoading(true);
    try {
      await approveCompany(selectedCompany._id);
      setCompanies((prev) =>
        prev.map((c) =>
          c._id === selectedCompany._id ? { ...c, isApproved: true } : c
        )
      );
      setShowDetailModal(false);
      setSelectedCompany(null);
    } catch (err) {
      setError("Failed to approve company.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleReject = async () => {
    if (!selectedCompany) return;
    setLoading(true);
    try {
      await rejectCompany(selectedCompany._id);
      setCompanies((prev) => prev.filter((c) => c._id !== selectedCompany._id));
      setShowDetailModal(false);
      setSelectedCompany(null);
    } catch (err) {
      setError("Failed to reject company.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // FILTER LIST USING SEARCH
  const filteredCompanies = companies.filter((c) => {
    const search = searchQuery.toLowerCase();

    return (
      c.name?.toLowerCase().includes(search) ||
      c.email?.toLowerCase().includes(search) ||
      c.phone?.toLowerCase().includes(search) ||
      c.category?.name?.toLowerCase().includes(search) ||
      c.subCategory?.name?.toLowerCase().includes(search)
    );
  });

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center fw-bold">🏢 Company Approval Management</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      {/* SEARCH INPUT */}
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Search by company name, email, phone, category..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table
          striped
          bordered
          hover
          responsive
          className="align-middle text-center shadow-sm"
        >
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Logo</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Category / SubCategory</th>
              <th>Status</th>
              <th>Registered By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredCompanies.length > 0 ? (
              filteredCompanies.map((company, index) => (
                <tr key={company._id}>
                  <td>{index + 1}</td>
                  <td>
                    {company.logo ? (
                      <Image
                        src={company.logo}
                        alt={company.name}
                        width={50}
                        rounded
                      />
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>{company.name}</td>
                  <td>{company.email}</td>
                  <td>{company.phone}</td>
                  <td>
                    {company.category?.name || "N/A"} /{" "}
                    {company.subCategory?.name || "N/A"}
                  </td>
                  <td>
                    <Badge bg={company.isApproved ? "success" : "warning"}>
                      {company.isApproved ? "Approved" : "Pending"}
                    </Badge>
                  </td>
                  <td>{company.registeredBy?.name || "N/A"}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="info"
                      className="me-2"
                      onClick={() => {
                        setSelectedCompany(company);
                        setShowDetailModal(true);
                      }}
                    >
                      🔍 View Details
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center text-muted">
                  No companies found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      {/* DETAIL MODAL */}
      <Modal
        show={showDetailModal}
        onHide={() => setShowDetailModal(false)}
        size="lg"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Company Full Details</Modal.Title>
        </Modal.Header>

        {selectedCompany && (
          <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <Row className="mb-3">
              <Col md={4}>
                {selectedCompany.logo && (
                  <Image
                    src={selectedCompany.logo}
                    alt="Logo"
                    fluid
                    rounded
                    style={{ maxHeight: "150px" }}
                  />
                )}
              </Col>

              <Col md={8}>
                <h4>{selectedCompany.name}</h4>
                <p><b>Email:</b> {selectedCompany.email}</p>
                <p><b>Phone:</b> {selectedCompany.phone}</p>
                <p>
                  <b>Website:</b>{" "}
                  <a href={selectedCompany.website} target="_blank">
                    {selectedCompany.website}
                  </a>
                </p>
                <p>
                  <b>Google Maps:</b>{" "}
                  <a href={selectedCompany.googleMapsLink} target="_blank">
                    {selectedCompany.googleMapsLink}
                  </a>
                </p>
                <p><b>Description:</b> {selectedCompany.description}</p>
                <p><b>Type:</b> {selectedCompany.companyType}</p>
                <p>
                  <b>Category/SubCategory:</b>{" "}
                  {selectedCompany.category?.name} /{" "}
                  {selectedCompany.subCategory?.name}
                </p>
                <p><b>GST Number:</b> {selectedCompany.gstNumber}</p>
                <p><b>Aadhaar Number:</b> {selectedCompany.aadhaarNumber}</p>
                <p>
                  <b>Registered By:</b>{" "}
                  {selectedCompany.registeredBy?.name} (
                  {selectedCompany.registeredBy?.email})
                </p>
                <p>
                  <b>Status:</b>{" "}
                  {selectedCompany.isApproved ? "Approved" : "Pending"}
                </p>
              </Col>
            </Row>

            <h5>Business Timings</h5>
            <Table size="sm" bordered>
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Open</th>
                  <th>Close</th>
                </tr>
              </thead>
              <tbody>
                {selectedCompany.businessTimings &&
                  Object.entries(selectedCompany.businessTimings).map(
                    ([day, timing]) => (
                      <tr key={day}>
                        <td>{day.charAt(0).toUpperCase() + day.slice(1)}</td>
                        <td>{timing.open || "--"}</td>
                        <td>{timing.close || "--"}</td>
                      </tr>
                    )
                  )}
              </tbody>
            </Table>

            <h5>Documents</h5>
            <Row>
              {selectedCompany.aadhaarImage && (
                <Col md={4} className="mb-2">
                  <p>Aadhaar</p>
                  <a href={selectedCompany.aadhaarImage} target="_blank">
                    <Image
                      src={selectedCompany.aadhaarImage}
                      fluid
                      rounded
                      style={{ maxHeight: "150px" }}
                    />
                  </a>
                </Col>
              )}

              {selectedCompany.panImage && (
                <Col md={4} className="mb-2">
                  <p>PAN</p>
                  <a href={selectedCompany.panImage} target="_blank">
                    <Image
                      src={selectedCompany.panImage}
                      fluid
                      rounded
                      style={{ maxHeight: "150px" }}
                    />
                  </a>
                </Col>
              )}

              {selectedCompany.electricityBillImage && (
                <Col md={4} className="mb-2">
                  <p>Electricity Bill</p>
                  <a
                    href={selectedCompany.electricityBillImage}
                    target="_blank"
                  >
                    <Image
                      src={selectedCompany.electricityBillImage}
                      fluid
                      rounded
                      style={{ maxHeight: "150px" }}
                    />
                  </a>
                </Col>
              )}

              {selectedCompany.passportPhoto && (
                <Col md={4} className="mb-2">
                  <p>Passport Photo</p>
                  <a
                    href={selectedCompany.passportPhoto}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image
                      src={selectedCompany.passportPhoto}
                      fluid
                      rounded
                      style={{ maxHeight: "150px" }}
                    />
                  </a>
                </Col>
              )}
            </Row>

            <h5>Banners</h5>
            <Row>
              {selectedCompany.banner?.map((b, i) => (
                <Col md={4} className="mb-2" key={i}>
                  <Image src={b} fluid rounded style={{ maxHeight: "150px" }} />
                </Col>
              ))}
            </Row>

            <h5>Keywords</h5>
            <p>
              {selectedCompany.keywords?.length
                ? selectedCompany.keywords.join(", ")
                : "N/A"}
            </p>

            <h5>Photos</h5>
            <Row>
              {selectedCompany.photos?.length ? (
                selectedCompany.photos.map((p, i) => (
                  <Col md={4} className="mb-2" key={i}>
                    <Image
                      src={p}
                      fluid
                      rounded
                      style={{ maxHeight: "150px" }}
                    />
                  </Col>
                ))
              ) : (
                <Col>
                  <p>N/A</p>
                </Col>
              )}
            </Row>
          </Modal.Body>
        )}

        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
          <div>
            {!selectedCompany?.isApproved && (
              <Button variant="success" onClick={handleApprove} className="me-2">
                ✅ Approve
              </Button>
            )}
            <Button variant="danger" onClick={handleReject}>
              ❌ Reject
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CompanyApproval;
